import { useState } from "react";

/**
 * Render-time analogue of a `useEffect` dependency list: true on the first
 * render and on any render where an entry differs (`Object.is`) from the
 * previous render, so state derived from external data can be reconciled
 * during render instead of one commit later.
 */
export function useDepsChanged(deps: readonly unknown[]): boolean {
  const [prev, setPrev] = useState<readonly unknown[] | null>(null);
  if (
    prev !== null &&
    prev.length === deps.length &&
    prev.every((dep, i) => Object.is(dep, deps[i]))
  ) {
    return false;
  }
  setPrev(deps);
  return true;
}
